import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from './utils';

export function useUserTimeTracking() {
  const location = useLocation();
  useEffect(() => {
    api && api.tracking.reportUrlChangeForTracking();
  }, [location]);
}
